import Link from 'next/link'
import React from 'react'

function AverageDevShop() {
   return (
      <section
         id="stats-section"
         className="page_top_section2 section_primary_bg dev-shop"
      >
         <div className="container-fluid dev-shop-border">
            <div className="top_section_content we-are-not-section container p-3">
               <h2 className="section_heading_title top_section_heading we-are-not-title">
                  We’re not your average dev shop.
               </h2>
               <div className="top_section_details">
                  We’re the ones who’ll wrestle a bug at 3 a.m., sketch ideas on
                  bar napkins, and push code live just to see if it breaks. Why?
                  Because good enough isn’t. Businesses, dreamers, and doers
                  come to us when they need tech that’s fast, fierce, and
                  future-proof. Since day one, we’ve shipped [X projects/ apps/
                  users served—pick a flex stat if you’ve got one] and learned
                  every lesson the hard way—so you don’t have to.
               </div>

               <Link
                  href="/discover-benzatine/contact-us"
                  className="btn-primary info_tell_btn mt-5"
               >
                  let’s talk to benzatine
                  <svg
                     className="arrow-icon"
                     width="36"
                     height="19"
                     viewBox="0 0 36 19"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path d="M35.766 9.15325L27.5843 0.971548C27.2904 0.628359 26.7739 0.588352 26.4307 0.882323C26.0876 1.17622 26.0475 1.69273 26.3415 2.03592C26.369 2.06798 26.3987 2.09772 26.4307 2.12514L33.2133 8.91595H0.822048C0.370228 8.91595 0.00390625 9.28227 0.00390625 9.73416C0.00390625 10.186 0.370228 10.5523 0.822048 10.5523H33.2133L26.4307 17.3349C26.0876 17.6288 26.0475 18.1453 26.3415 18.4885C26.6355 18.8317 27.1519 18.8717 27.4951 18.5777C27.5272 18.5502 27.5569 18.5205 27.5843 18.4885L35.766 10.3068C36.0832 9.98777 36.0832 9.47239 35.766 9.15325Z" />
                  </svg>
               </Link>
            </div>
         </div>
      </section>
   )
}

export default AverageDevShop
